export default {
  // Title
  input: "Input",

  // Buttons
  collapseAll: "Collapse All",
  viewAll: "View All",

  // Message prompts
  copySuccess: "Copy successful!",
};
